import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  error: undefined,
  result: undefined,
  isValid: false,
};

const setData = (store, data) => {
  store.setState((state) => {
    state.cuenta.empresas.info.data = { ...data };
  });
};

const get = async (store, id, params = {}) => {
  store.setState((state) => {
    state.cuenta.empresas.info.busy = true;
  });

  try {
    const response = await Http.get(`api/empresas/${id}`, { params });

    store.setState((state) => {
      state.cuenta.empresas.info.data = response.data;
      state.cuenta.empresas.info.busy = false;
    });

    return response.data;
  } catch (error) {
    store.setState((state) => {
      state.cuenta.empresas.info.error = error.data || error;
      state.cuenta.empresas.info.busy = false;
    });
  }
};

const resetError = (store) => (state) => {
  state.cuenta.empresas.info.error = undefined;
};

const reset = (store) => (state) => {
  state.cuenta.empresas.info = { ...initialState };
};

const actions = {
  setData,
  get,
  reset,
  resetError,
};

const EmpresasInfoStore = {
  state: () => initialState,
  actions,
};

export default EmpresasInfoStore;
